import React from 'react';
import { Row, Col } from 'reactstrap';
import greens1 from '../assets/img/greens.png';
import greens2 from '../assets/img/greens2.png';

const Greens = ({ children, green = 2, paddingTop }) => {
  return (
    <Row>
      <Col
        className="greens-bg mt-4 text-center"
        style={{
          // border: '1pt solid #000',
          backgroundImage: `url(${green === 1 ? greens1 : greens2})`,
          paddingTop
        }}
      >
        {children}
      </Col>
    </Row>
  );
};

export default Greens;
